import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityAdmissionService} from '../../../shared/services/university-admission.service';
import {UniversityService} from '../../../shared/services/university.service';
import {environment} from '../../../../environments/environment';

import {UtilsService} from '../../../shared/services/utils.service';

interface OverviewEditorBlock {
    type: 'content' | 'table';
    value: string;
}

@Component({
    selector: 'app-university-admission',
    templateUrl: './university-admission.component.html',
    styleUrls: ['./university-admission.component.scss']
})
export class UniversityAdmissionComponent implements OnInit {
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    submitting: any = false;
    submitted: any = false;
    dataExists: any = false;
    university: any;
    editorBlocks: OverviewEditorBlock[] = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityAdmissionService: UniversityAdmissionService,
                private universityService: UniversityService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.getUniversityAdmissionDetail();
            }
        });
    }

    getUniversityAdmissionDetail() {
        this.universityAdmissionService.detailByAdmin(this.universityId).subscribe(data => {
            this.dataExists = !!(data && data['info']);
            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    submit() {
        this.submitting = true;
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);
        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
        };
        if (this.dataExists) {
            this.universityAdmissionService.updateByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        } else {
            this.universityAdmissionService.createByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
